import jQuery from 'jquery';

export const AppearObserver = {
  options: {
    elements: null,
    appearedClass: 'appeared',
    root: null,
    rootMargin: '0px',
    threshold: 0
  },

  _create: function () {
    // Allow multiple elements managed by one observer.
    this.elements = this.options.elements ? this.element.find(this.options.elements) : this.element;

    if (IntersectionObserver) {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this._appear(jQuery(entry.target), entry);
            observer.unobserve(entry.target);
          }
        });
      }, {
        root: this.options.root,
        rootMargin: this.options.rootMargin,
        threshold: this.options.threshold
      });
      this.elements.each((_, element) => {
        observer.observe(element);
      });
    }
    else {
      // If IntersectionObserver is not supported, let all elements appear immediately after a short delay.
      setTimeout(() => { this._appear(this.elements); }, 500);
    }
  },

  _appear: function (element, entry) {
    element.addClass(this.options.appearedClass);
    element.trigger({type: 'appear', entry});
  }
};
